import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";

const baseRing =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-olive/60 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-cream";

export const PrimaryCTA = ({ to, children, testId, external, ...rest }) => {
  const cls = `group inline-flex items-center gap-2 bg-brand-olive hover:bg-brand-hover text-brand-cream pl-6 pr-5 py-3.5 text-sm font-medium tracking-wide rounded-full transition-colors ${baseRing}`;
  const arrow = (
    <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-brand-cream text-brand-olive transition-transform duration-300 group-hover:translate-x-0.5">
      <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={2.2} />
    </span>
  );
  if (external) {
    return (
      <a href={to} data-testid={testId} className={cls} {...rest}>
        {children}
        {arrow}
      </a>
    );
  }
  return (
    <Link to={to} data-testid={testId} className={cls} {...rest}>
      {children}
      {arrow}
    </Link>
  );
};

export const SecondaryCTA = ({ to, children, testId, ...rest }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group inline-flex items-center gap-2 border border-brand-muted/40 hover:border-brand-muted/70 text-brand-deep px-6 py-3.5 text-sm font-medium tracking-wide rounded-full transition-colors hover:bg-brand-border ${baseRing}`}
    {...rest}
  >
    {children}
    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5" />
  </Link>
);
